import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { User } from '../models/user.model';
import { HttpService } from 'src/app/shared/http.service';
import { Router } from '@angular/router';
import { JwtHelperService } from "@auth0/angular-jwt";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  JWThelper = new JwtHelperService();
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: User;
  isLoggedIn: boolean;

  constructor(private httpAppLayerService: HttpService, private router: Router) { }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  login(data) {
    return this.httpAppLayerService.postData('users/login', false, data).then(data => {
      this.currentUser = data;
      if (this.currentUser && this.currentUser.token) {
        localStorage.setItem('token', this.currentUser.token);
        this.isLoggedIn = true;
        this.router.navigate(['/']);
        return true
      }
    }, err => {
      this.isLoggedIn = false;
      return false;

    })
  }

  logout() {
    return this.httpAppLayerService.getData('users/logout', true).then(data => {
      // remove user from local storage to log user out
      localStorage.removeItem('token');
      this.isLoggedIn = false;
      this.router.navigate(['/login']);

    }, err => {
      localStorage.removeItem('token');
      this.isLoggedIn = false;
      this.router.navigate(['/login']);
    })
  }

  checkForUser() {

    let myRawToken = localStorage.getItem('token');
    if (!myRawToken) return false;
    const decodedToken = this.JWThelper.decodeToken(myRawToken);
    const isExpired = this.JWThelper.isTokenExpired(myRawToken);
    if (isExpired) return false;
    this.isLoggedIn = true;
    return decodedToken;

  }


  isUserLoggedIn() {
    return this.isLoggedIn;
  }


  userInfo() {
    return this.httpAppLayerService.getData('users/me', true);
  }



}
